<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="scope !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.datascope.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <div *ngIf="showDeactivateWarning()" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.deactivate_data_scope') }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="showEmptyDimensionWarning()" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.empty_dimension_no_access') }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="showDimensionChangeWarning()" role="alert" class="p-messages p-component p-mb-4">
      <div role="alert" class="p-message p-message-warn">
        <div class="p-message-wrapper">
          <span class="p-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
          <span class="p-message-detail">{{ t('common.messages.change_data_scope_dimensions') }}</span>
        </div>
      </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="scope.name"></app-form-control>
        <app-form-control [cid]="'dimensions'" [control]="form.get('dimensions')" [type]="'multiselect'" [label]="t('common.labels.dimensions')" [edit]="inEdit" [basevalue]="getDimensionsLabel()" [options]="dimensionOptions" [optionLabel]="'label'" [dataKey]="'key'" [showClear]="true"></app-form-control>
        <app-form-control [cid]="'active'" [control]="form.get('active')" [type]="'checkbox'" [label]="t('common.labels.active')" [edit]="inEdit" [basevalue]="scope.active"></app-form-control>

      </div>
      <div class="p-col-12 p-md-6">

        <app-form-control [cid]="'title_de'" [control]="form.get('title_de')" [type]="'input'" [label]="t('common.labels.title') + ' (DE)'" [edit]="inEdit" [basevalue]="scope.title && scope.title['DE']"></app-form-control>
        <app-form-control [cid]="'title_en'" [control]="form.get('title_en')" [type]="'input'" [label]="t('common.labels.title') + ' (EN)'" [edit]="inEdit" [basevalue]="scope.title && scope.title['EN']"></app-form-control>
        <app-form-control [cid]="'description'" [control]="form.get('description')" [type]="'textarea'" [label]="t('common.labels.description')" [edit]="inEdit" [basevalue]="scope.description"></app-form-control>

      </div>
    </div>

  </form>
</ng-container>
